import { checkPermissions } from 'react/utils/utils';

class ReportsRouter extends App.Routers.GenericForm {
  constructor() {
    super('Reports', 'Reports');
  }

  addElementAtPosition = (parentElement, position, elementToAdd) => {
    const children = Array.from(parentElement.children);
    children.splice(position, 0, elementToAdd);
    parentElement.innerHTML = '';
    children.forEach((el) => parentElement.appendChild(el));
  };

  renderTimezoneAlert = () => {
    const { timeZone, organization } = Monet.Session.ApplicationLoad.loggedUser;

    if (!timeZone && !organization) return;

    let timezone = '';
    let resourceMessage = '';

    if (organization) {
      resourceMessage = Monet.I18n.getResourcesByKey(
        'Report.TimeZoneMessage.Organization'
      );
      timezone = organization.timeZone.timezoneName;
    }

    if (timeZone) {
      resourceMessage = Monet.I18n.getResourcesByKey(
        'Report.TimeZoneMessage.User'
      );
      timezone = timeZone.timezoneName;
    }

    const messageWithTimeZone = resourceMessage.replace('xxxx', timezone);
    const formRouteHtml = document.querySelector('.MonetUIForm.Reports');

    const reportMessageContainer = document.createElement('div');
    reportMessageContainer.classList.add('report-message');
    reportMessageContainer.innerHTML = `
        <span></span>
        <p>${messageWithTimeZone}</p>
      `;

    this.addElementAtPosition(formRouteHtml, 2, reportMessageContainer);
  };

  afterCreateForm = (userInterface) => {
    if (App.Forms.Reports) {
      const form = App.Forms.Reports.form;
      const { fields, help } = form;
      const title = help?.title;
      const reportTypes = form.fields.reportType;
      const reportTLength = reportTypes.getRadioButtons().length;
      const isReportTaskForm = this.checkIfIsReportTask({ fields, title });

      this.setInitialReportType(reportTypes, reportTLength);

      this.setReportButtonsOnClick(form, userInterface);
      this.handleOptionalFields();

      this.adjustSectionFieldsForiPad();

      this.handleSurveyTabularForm(userInterface);

      if (isReportTaskForm) {
        this.addHelpEndDateButton();
      }
      if (userInterface === 'RouteperformanceReportForm') {
        this.renderTimezoneAlert();
      }
    }
  };

  setInitialReportType = (reportTypes, reportTLength) => {
    const setReportType = () => {
      const pdfRadio = reportTypes.getRadioButton('pdf');
      if (pdfRadio) {
        pdfRadio.setChecked(true);
      } else {
        reportTypes.getRadioButton('xls')?.setChecked(true);
      }
    };

    if (reportTLength === 1) {
      reportTypes.getRadioButtons()[0]?.setChecked(true);
    } else {
      setReportType();
    }
  };

  setReportButtonsOnClick = (form, userInterface) => {
    const btns = form.getAllButtons();
    const getReport = () => this.requestReport(userInterface, 'html');
    btns.forEach((btn) => {
      btn.input.onclick = getReport;
    });
  };

  handleOptionalFields = () => {
    const containerUserManager = document.querySelector(
      '#Reports #Reports_userManager'
    );
    if (containerUserManager) {
      this.updateFieldUserManager();
    }

    const existLookupSurveyQuestion = document.querySelector(
      '#Reports #Reports_surveyquestion'
    );
    if (existLookupSurveyQuestion) {
      this.updateBodySurveyQuestion();
    }

    const existLookupOnlyYesSkuQuestionsAnswers = document.querySelector(
      '#Reports #Reports_onlyYesSkuQuestionsAnswers'
    );
    if (existLookupOnlyYesSkuQuestionsAnswers) {
      this.updateBodyOnlyYesSkuQuestionsAnswersField();
    }

    const existLookupTag = document.querySelector('#Reports #Reports_tag');
    if (existLookupTag) {
      this.updateCriteriaTagField();
    }
  };

  adjustSectionFieldsForiPad = () => {
    const sectionFields = document.querySelector(
      '#Reports .MonetUIFormSectionFields'
    );
    const isiPad = /iPad/i.exec(navigator.userAgent) !== null;
    if (sectionFields && isiPad) {
      sectionFields.style.marginLeft = '-60px';
      const columns = sectionFields.querySelectorAll(
        '.MonetUIFormSectionColumn'
      );
      Array.from(columns).forEach((column) => {
        if (column?.style) {
          column.style.paddingLeft = '0px';
          column.style.width = '425px';
          column.style.marginLeft = '-10px';
        }
      });
    }
  };

  generateForm = (
    routePrefix,
    userInterface,
    userInterfaceAction,
    data,
    beforeCreateForm,
    afterCreateForm,
    tabName
  ) => {
    const callback = () => {
      const baseRouter = new App.Routers.BaseRouter();
      const tabSelector = !tabName ? routePrefix + userInterface : tabName;

      const form = baseRouter.renderMonetForm(tabName, data, tabSelector);
      if (!checkPermissions('TAG_LIST')) {
        form?.getFields()?.tag?.disableAll();
      }
      setTimeout(() => {
        afterCreateForm(userInterface, userInterfaceAction, data);
      }, 1000);
    };

    if (beforeCreateForm) {
      beforeCreateForm(userInterface, callback);
    }

  };

  beforeCreateForm = (userInterface, callback) => {
    let formRouteHtml = {};
    let divNodeTreeview = {};
    if (typeof this.tabName === 'undefined') {
      formRouteHtml = document.querySelector(
        '#Reports' + userInterface + ' .form_and_grid_generic'
      );
      divNodeTreeview = document.createElement('div');
      if (formRouteHtml !== null) {
        divNodeTreeview.setAttribute('id', 'treeViewForm');
        divNodeTreeview.setAttribute('style', 'width: 18%;');
        formRouteHtml.setAttribute('style', 'width: 82%; float:right');
        formRouteHtml.parentNode.insertBefore(divNodeTreeview, formRouteHtml);
      }
    } else {
      const treeview = document.getElementById('treeViewForm');
      formRouteHtml = document.querySelector('#Reports .form_and_grid_generic');

      divNodeTreeview = document.createElement('div');

      if (formRouteHtml !== null && treeview === null) {
        divNodeTreeview.setAttribute('id', 'treeViewForm');
        formRouteHtml.setAttribute('style', 'width: 82%; float:right');
        formRouteHtml.parentNode.insertBefore(divNodeTreeview, formRouteHtml);
      }
    }

    this.requestRouteMenu(userInterface, callback);
  };

  updateFieldUserManager = function () {
    const defaultCriteriaForFields = {
      criteriaChain: [
        {
          and: [
            { attr: 'name', matchMode: 'ANYWHERE' },
            { attr: 'userAllowedDrivers.id', isNull: false }
          ]
        }
      ]
    };

    const { lookupElement } = App.Forms.ReportsLookupUserManager;
    if (!lookupElement) return;

    lookupElement.setRequestFilter(
      '/restrictions?criteria={"filters":["*"],"firstResult":0,"maxResults":10}'
    );
    lookupElement.setRequestBody(defaultCriteriaForFields);
    lookupElement.setInputName('user');
  };

  updateBodySurveyQuestion = () => {
    const { lookupElement } = App.Forms.ReportsSurveyquestionLookup;
    if (!lookupElement) return;
    const callbackFunctionSurveyQuestion = () => {
      lookupElement.filter.callbackBeforeFilter = () => {
        const arrayIdsOfSurvey = [];
        const selectedSurveys =
          App.Forms.ReportsSurveyDescriptionLookup.lookupElement.getValue();

        if (this.criteriaChain.criteriaChain[0]) {
          this.criteriaChain.criteriaChain[0].and.push({
            attr: 'type',
            neq: 'SKU'
          });
        }

        if (selectedSurveys.length) {
          for (const survey of selectedSurveys) {
            arrayIdsOfSurvey.push(survey.id);
          }
          this.criteriaChain.criteriaChain[0].and.push({
            attr: 'surveySection.survey.id',
            in: arrayIdsOfSurvey
          });
        }
      };
    };

    lookupElement.setAfterCreateFilter(callbackFunctionSurveyQuestion);
    if (lookupElement.filter) {
      callbackFunctionSurveyQuestion();
    }
  };

  updateCriteriaTagField = () => {
      const { lookupElement } = App.Forms.ReportsTagLookup;

    lookupElement.filter.changeCriteriaBeforeFilter = (criteria) => {
      const filter = { attr: 'tagType', eq: 'ROUTE' };
      criteria.criteriaChain[0].and.push(filter);
      return criteria;
    };
  };

  addHelpEndDateButton = () => {
    const endDateFieldContainer = document.querySelector(
      '#Reports_intervalEnd'
    );

    if (endDateFieldContainer) {
      const divButton = document.createElement('div');
      const tooltip = document.createElement('p');
      tooltip.className = 'gmInfoTooltip';
      tooltip.innerHTML = Monet.I18n.getResourcesByKey(
        'Reports.Tooltip.intervalEndTasks'
      );
      divButton.className = 'btn';
      divButton.appendChild(tooltip);

      endDateFieldContainer.appendChild(divButton);
    }
  };

  updateBodyOnlyYesSkuQuestionsAnswersField = () => {
    const { lookupElement } = App.Forms.ReportsOnlyYesSkuQuestionsAnswersLookup;
    if (!lookupElement) return;
    const callbackFunction = () => {
      lookupElement.filter.callbackBeforeFilter = () => {
        const arrayIdsOfSurvey = [];
        const selectedValues =
          App.Forms.ReportsSurveyDescriptionLookup.lookupElement.getValue();

        if (this.criteriaChain.criteriaChain[0]) {
          this.criteriaChain.criteriaChain[0].and.push({
            attr: 'type',
            eq: 'SKU'
          });
        }

        console.log(
          '[OnlyYesSkuQuestionsAnswers] SelectedValues on SurveyDescriptionLookup = ',
          selectedValues
        );
        if (selectedValues.length) {
          for (const element of selectedValues) {
            arrayIdsOfSurvey.push(element.id);
          }
          this.criteriaChain.criteriaChain[0].and.push({
            attr: 'surveySection.survey.id',
            in: arrayIdsOfSurvey
          });
        }
      };
    };

    lookupElement.setAfterCreateFilter(callbackFunction);
    if (lookupElement.filter) {
      callbackFunction();
    }
  };

  createHtmlMenu = (collection, userInterface) => {
    const formRouteHtml = document.querySelector('#Reports #treeViewForm');
    const title = Monet.I18n.getResourcesByKey('Reports.SideMenu.Headers');
    const reportsEl = document.querySelector('.gmTabs__panel #Reports');

    if (formRouteHtml !== null) {
      let menuString = `<h1>${title}</h1>`;
      menuString += '<ul class="sideMenuItem">';

      for (let i = 0, j = collection.size(); i < j; i++) {
        const model = collection.at(i);
        if (model.get('userInterface').key === userInterface) {
          menuString += `<li class="sideMenuItem currentItem" key="${
            model.get('userInterface').key
          }">`;
        } else {
          menuString += `<li class="sideMenuItem" key="${
            model.get('userInterface').key
          }">`;
        }

        menuString +=
          '<a href="#/Reports/' +
          model.get('userInterface').key +
          '/' +
          model.get('userInterfaceAction').key +
          '" class="sideMenuItem">';
        menuString += Monet.I18n.getResourcesByKey(
          model.get('descriptionResourceId')
        );
        menuString += '</a>';
        menuString += '</li>';
      }

      menuString += '</ul>';
      formRouteHtml.innerHTML = menuString;
    }

    if (reportsEl.parentNode) reportsEl.parentNode.style.overflowY = 'auto';
  };

  requestRouteMenu = async (userInterface, callback) => {
    const reports = new App.Collections.Reports();
    reports.comparator = (model) => model.get('titleResourceId');

    reports.fetchWithCriteria({
      criteria:
        '{"filters":["*","userInterface.key", "userInterfaceAction.key", "userInterfaceAction.permissionKey"]}',
      method: 'get',
      success: (collectionData) => {
        collectionData.models = collectionData.models.filter((model) =>
          checkPermissions(model.get('userInterfaceAction').permissionKey)
        );
        collectionData.sort();
        this.createHtmlMenu(collectionData, userInterface);
        if (callback) {
          callback(userInterface);
        }
      }
    });
  };

  requestReport = (userInterface) => {
    const form = App.Forms.Reports.form;
    const validate = form.validate();

    this.intervalDateIsOk(validate);

    if (validate.status) {
      const report = new App.Collections.Reports();

      form.triggerLoadingBtns();
      this.removeMessageError();

      $('iframe').remove();
      $(
        '<iframe sandbox="allow-scripts allow-forms allow-same-origin allow-downloads allow-modals allow-presentation" id="reportSubmit" width="1" heigth="1" style="visibility:hidden"/>'
      )
        .trigger('load')
        .appendTo($('#' + Monet.Utils.GetTabName()));

      report.filterWithCriteria({
        criteria: '{"filters":["id"]}',
        filter: `{"userInterface": { "key" :"${userInterface}"}}`,
        success: (data) => {
          $('#reportSubmit')
            .contents()
            .find('body')
            .html(this.makeReportForm(data, userInterface));
          this.requestForm();
        }
      });

      setTimeout(() => {
        form.triggerLoadingBtns();
      }, 1500);
    } else {
      const monetMessage = new Monet.Form.Messages.InlineMessage();
      monetMessage.setScope('#Reports');
      monetMessage.setInfoType('error');
      monetMessage.setMessage(validate);
      monetMessage.triggerMessage();
    }
  };

  makeReportForm = (collection) => {
    const fields = App.Forms.Reports.form.fields;
    const formType = fields.reportType.getOptionSelected().getValue();
    const request = {
      action: `Report/${collection.first().get('id')}/${formType}`,
      formData: {
        timezoneOffSet: new Date().getTimezoneOffset(),
        filters: {}
      },
      formType: formType
    };
    App.Forms.Reports.form.request = request;

    for (let keyField in fields) {
      const name = fields[keyField].name;

      if (keyField !== 'reportType') {
        if (fields[keyField].getValue() instanceof Array) {
          const listValue = fields[keyField].getValue();
          const collection = [];
          App.Forms.Reports.form.request.formData.filters[name] = collection;
          for (let j = 0, size = listValue.length; j < size; j++) {
            collection.push({ id: listValue[j].id });
          }
        } else {
          App.Forms.Reports.form.request.formData.filters[name] =
            fields[keyField].getValue();
        }
      }
    }
  };

  requestForm = () => {
    const { action, formData, formType } = App.Forms.Reports.form.request;
    const modal = this.showModal();
    const ajax = new Monet.Ajax();

    modal.showModalForm();

    ajax.url = action;
    ajax.method = 'post';
    ajax.data = formData;
    ajax.success = (data) => {
      window.open(
        `Report/${formType}/download/${data.url}`,
        '_blank',
        'noopener,noreferrer',
        true
      );
      modal.closeModalWindow();
    };
    ajax.error = () => modal.closeModalWindow();
    ajax.send();

    App.Forms.Reports.form.request = {};
  };

  showModal = () => {
    const selector = '#Reports';
    const scopeBlock = '#Reports';

    const options = {
      width: 400,
      height: 250
    };

    const callbacks = {
      onAfterShowModalForm: function () {
        const popupFormContainer = $('#Reports .popupFormContainer');
        const closeModalWindow = $('#Reports .closeModalWindow');
        const image = require('static/images/general/loading_blue.svg');
        const img = '<div class="loading"><img src="' + image + '"></div>';

        popupFormContainer.hide();
        closeModalWindow.hide();

        $('.blockUI.blockOverlay').html(img);
      }
    };

    return new Monet.Form.Modal(selector, options, callbacks, scopeBlock);
  };

  checkIfIsReportTask = ({ title, fields }) => {
    const { reportType } = fields;
    const REPORT_TASK_DESCRIPTION = 'portType_ReporteDeTareas';
    const REPORT_TASK_HELP_TITLE =
      'ReporteDeTareasReport.userinterface.description';
    const hasReportTaskField =
      reportType?.field?.description === REPORT_TASK_DESCRIPTION;
    const hasReportTaskTitle = title === REPORT_TASK_HELP_TITLE;

    return hasReportTaskField || hasReportTaskTitle;
  };

  intervalDateIsOk = (result) => {
    try {
      const form = App.Forms.Reports.form;
      const { fields, help } = form;
      const title = help?.title;
      const intervalStart = fields.intervalStart;
      const intervalEnd = fields.intervalEnd;
      const MAX_INTERVAL_DATES_DIFF = 90;
      const isTaskReportForm = this.checkIfIsReportTask({ fields, title });

      if (!intervalEnd || !intervalStart) {
        return result;
      }

      const dateInitial = intervalStart.getValue();
      const dateFinal = intervalEnd.getValue();

      if (!dateInitial || !dateFinal) {
        return result;
      }

      const date = new Monet.Date.GeneralFunctions();

      if (date.validateIfDateIsInFuture(dateInitial)) {
        result.status = false;
        result.errorMessages.push(
          Monet.Form.Messages.mountErrorMessageObject(
            'Reports.MessageError.dateInitialIsInFuture'
          )
        );
      }

      if (date.validateIfDateIsInFuture(dateFinal)) {
        result.status = false;
        result.errorMessages.push(
          Monet.Form.Messages.mountErrorMessageObject(
            'Reports.MessageError.dateFinalIsInFuture'
          )
        );
      }

      if (!date.validateDateGreaterOrEqualThan(dateInitial, dateFinal)) {
        result.status = false;
        result.errorMessages.push(
          Monet.Form.Messages.mountErrorMessageObject(
            'Reports.MessageError.dateInitialIsGreaterThanDateEnd'
          )
        );
      }

      if (
        date.checkIfDateIntervalGreaterThanAllowed({
          dateInitial,
          dateFinal,
          maxRangeInDays: MAX_INTERVAL_DATES_DIFF
        }) &&
        isTaskReportForm
      ) {
        result.status = false;
        result.errorMessages.push(
          Monet.Form.Messages.mountErrorMessageObject(
            'Reports.MessageError.dateIntervalGreaterThanAllowed'
          )
        );
      }

      return result;
    } catch (e) {
      const error = new Monet.Exception.ReturnError(
        this,
        'Error validate interval date.',
        e
      );
      error.console();
    }
  };

  removeMessageError = () => {
    try {
      const divError = document.querySelector(
        '#Reports .monetInlineAlerContainer .alert'
      );
      if (divError) {
        const divParent = divError.parentNode;
        divParent.removeChild(divError);
      }
    } catch (e) {
      const error = new Monet.Exception.ReturnError(
        this,
        'Error on remove message error.',
        e
      );
      error.console();
    }
  };

  handleSurveyTabularForm = (userInterface) => {
    if (userInterface === 'SurveyTabularReportForm') return;

    const fields = App.Forms.Reports.form.fields;
    const surveyField = fields?.surveyDescription;
    if (!surveyField) return;

    const disableSurveyField = () => surveyField?.disableAll();
    const prepareFilter = (organizations) => {
      const organizationsWithDescription = organizations.reduce(
        (list, organization) => {
          list.push(organization.description);

          return list;
        },
        []
      );

      const setCriteria = (criteria) => {
        const filterSpecificOrganization = {
          attr: 'surveyOrganizations.organization.description',
          in: organizationsWithDescription
        };
        const filterParentOrganization = {
          attr: 'organization.description',
          in: organizationsWithDescription
        };
        const hasCriteriasFromFilterFields =
          criteria.criteriaChain[0].and.length;

        if (hasCriteriasFromFilterFields) {
          criteria.criteriaChain.push({
            or: [filterParentOrganization, filterSpecificOrganization]
          });
        } else {
          criteria.criteriaChain[0].or = [
            filterParentOrganization,
            filterSpecificOrganization
          ];
        }

        return criteria;
      };

      surveyField.filter.changeCriteriaBeforeFilter = setCriteria;
    };

    const updateSurveyFieldValues = (organizations) => {
      const surveysSelecteds = surveyField.getSelectedValues();
      const suveysSelectedsList = Object.values(surveysSelecteds);

      const updateByOrganizationFieldValues = (survey) =>
        organizations.some((organization) => {
          let isToKeepThisValue = false;

          if (survey?.organization) {
            isToKeepThisValue = organization.id === survey.organization.id;
          }

          if (!isToKeepThisValue && survey?.surveyOrganizations?.length) {
            isToKeepThisValue = survey.surveyOrganizations.some(
              (surveyOrganization) =>
                surveyOrganization.organization.id === organization.id
            );
          }

          return isToKeepThisValue;
        });

      const surveysUpdated =
        suveysSelectedsList &&
        suveysSelectedsList.filter(updateByOrganizationFieldValues);

      surveyField.clear({ doNotTriggerChange: true });
      surveyField.setValue(surveysUpdated);
    };

    disableSurveyField();

    surveyField.setCustomProjectionToSelectAll({
      filters: [
        'id',
        surveyField.displayKey,
        'organization.id',
        'organization.description',
        'surveyOrganizations.*',
        'surveyOrganizations.organization.id',
        'surveyOrganizations.organization.description'
      ],
      firstResult: 0,
      maxResults: 1000
    });

    fields.organization.setOnChange(function () {
      const organizations = this.getValue();

      if (organizations?.length) {
        prepareFilter(organizations);
        surveyField.enableAll();
        updateSurveyFieldValues(organizations);
      } else {
        surveyField.clear({ doNotTriggerChange: true });
        disableSurveyField();
      }
    });
  };
}

App.Routers.Reports = ReportsRouter;
